import Shimmer from '../Shimmer/Shimmer'
import { useSelector } from 'react-redux'
import LoaderComponent from './LoaderComponent'

const Loader = () => {
    const isMobile = useSelector((state: any) => state?.navigation?.isMobile)
    return (
        isMobile ?<Shimmer />: <LoaderComponent /> 
    )
}

export default Loader